export default "__VITE_ASSET__FhiTzr39__"